// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + {"86":"hexells","406":"vanta-waves","971":"three-js"}[chunkId] + "." + {"86":"cca4e90b17dd13cc0b40","406":"a4903f6fbe7940ba4b96","971":"d65a4ae0c7eaf995237e"}[chunkId] + ".bundle.js";
};